<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_1"></a>Praise for <em>The Book of Knights</em></p>
<p class="noindent"> </p>
<p class="noindent">“At once sharp and humane, revealing just what it means to be human, however strange one’s world. <em>The Book of Knights</em> offers a fantasy with a refreshing difference, and wisdom.”</p>
<p class="attributea">—<em>Locus</em></p>
<p class="noindent">“One of the brilliant new-generation writers coming out of the recent extraordinary growth period of Canadian speculative fiction, Yves Meynard manages to be both lyrical and tough at once, writing fluent and evocative stories in either English or French. His stories create a gestalt of literary and genre traditions from classical to cyberpunk.”</p>
<p class="attributea">—Candas Jane Dorsey</p>
<p class="noindent">“Yves Meynard is an exciting new voice, refreshingly different.”</p>
<p class="attributea">—Robert J. Sawyer</p>
<p class="noindent">“I read Yves Meynard’s <em>The Book of Knights</em> in one sitting. It’s a lovely, lively, truly enchanting book, filled with wonders and nightmares, and not a little wisdom.”</p>
<p class="attributea">—Susan Palwick</p>
<p class="noindent">“In <em>The Book of Knights</em> Yves Meynard has written a novel that is <em>about</em> something. From the ancient materials of myth, folklore, legend, he has fashioned a work that is wonderfully new and wonderfully wise. Here is literary alchemy of the highest order, resulting in seamless Art.”</p>
<p class="attributea">—Terence M. Green</p>
<p class="noindent">“Enriched by both American and European fantasy traditions (a twisted reminiscence of Hoffmann, for instance), here is a deftly spare picaresque novel, a story looking sideways, with love and gentle irony, at the traditional, even archaic, tropes of fantasy. A Don Quixote in his own way, the young but no-nonsense hero believes enough in the marvelous to make the world of his Book of Knights real, even while he returns to his mundane world to transform it. The characters, the places, the tone and mood, all seem to indicate a possible successor to Jack Vance. And better yet, he will still be Yves Meynard.”</p>
<p class="attributea">—Élisabeth Vonarburg</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PraiseforTheBookofKnights.vue?d9e8f236